module.exports = __webpack_public_path__ + "img/part_tab2_box1.b6af7996.png";